import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RestService } from 'src/app/services/rest/rest.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  form: FormGroup;

  constructor(private fb: FormBuilder,
    private utils: UtilsService,
    private rest: RestService,
    private storage: StorageService,
    private router: Router) {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  async login() {

    const username = this.form.get('username').value;
    const password = this.form.get('password').value;
    await this.utils.showLoading();

    // TODO: Login logic
    try {
      const resp = await this.rest.login(username, password);
      await this.utils.hideLoading();
      localStorage.setItem('usuario', JSON.stringify(resp));
      console.log(resp);

      if (resp) {
        this.router.navigate(['/clientes']);
        await this.utils.showToast('¡Bienvenido!', 'success');
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Username o contraseña incorrecta', 'danger');
      }

    } catch (error) {
      await this.utils.hideLoading();
      await this.utils.showToast('Username o contraseña incorrecta', 'danger');
    }
  }
  ngOnInit() {
  }

}
